import { Fragment, useRef } from 'react'
import { Container } from 'react-bootstrap'
import { DateComponent, Input, VerifyInput,TextArea, RadioInput, DropdownV1, Label, Upload, Checkbox, SubHeader, RadioQuestion, OTP, RadioCheckbox, Toggle, ButtonV1, DobComponent,Location, Liveness,InputSuggestion,MultiSelectCheckbox, MultiSelectDropdown ,SingleSelectDropdown  } from 'lib'
import { useDispatch } from 'react-redux'
import "./index.scss"
import FormButton from 'components/FormButton'
// import { IndirectEval } from 'helper/indirectEval'
const CardForm = (props) => {
  const {
    formErr,
    clearFieldError,
    setSelectedData,
    selectedData,
    inputFields,
    getSelectedValue,
    saveFormFields,
    handleNext
  } = props;

  const stateErrRef = useRef();
  const selectedDataRef = useRef();

  const dispatch = useDispatch()
  stateErrRef.current = { ...formErr };
  selectedDataRef.current = { ...selectedData };

  const IndirectEval = (evalString) =>{
    return eval(evalString)
}

  const handleChange = (e) => {
    const { name, value } = e.target
    clearFieldError(name)
    dispatch(setSelectedData({ key: name, value: value }))
  }

  const handleDateChange = (date, name) => {
    clearFieldError(name)
    dispatch(setSelectedData({ key: name, value: date }))
  }

  const handleDobChange = (dob, name) => {
    clearFieldError(name)
    dispatch(setSelectedData({ key: name, value: dob }))
  }

  const handleRadioChange = (e) => {
    const { name, value } = e.target
    // console.log(name, value);
    clearFieldError(name)
    dispatch(setSelectedData({ key: name, value: value }))
  }

  const handleDropdown = (e) => {
    const { name, value } = e.target
    clearFieldError(name)
    dispatch(setSelectedData({ key: name, value: value }))
  }

  const handleCheckBoxChange = (e) => {
    const { name, value } = e.target
    clearFieldError(name)
    dispatch(setSelectedData({ key: name, value: value }))
  }

  const handleRadioQuestionChange = (e) => {
    const { name, value } = e.target
    clearFieldError(name)
    dispatch(setSelectedData({ key: name, value: value }))
  }

  const handleRadioCheckboxChange = (e) => {
    const { name, value } = e.target
    clearFieldError(name)
    dispatch(setSelectedData({ key: name, value: value }))
  }

  const handleToggleChange = (name, value) => {
    clearFieldError(name)
    dispatch(setSelectedData({ key: name, value: value }))
  }

  const handleOTPChange = (name, value) => {
    clearFieldError(name)
    dispatch(setSelectedData({ key: name, value: value }))
  }

  const checkFieldVisibility = field => {
    const dependent_field = field?.show
    if (dependent_field) {
      return (IndirectEval(dependent_field))
    }
    return true;
  };

  //field map
  const FieldMap = {
    text: {
      component: Input,
      onChange: handleChange,
    },
    verifyText: {
      component: VerifyInput,
      onChange: handleChange,
    },
    number: {
      component: Input,
      onChange: handleChange,
    },
    email: {
      component: Input,
      onChange: handleChange,
    },
    date: {
      component: DateComponent,
      onChange: handleDateChange,
      selectedData: selectedData
    },
    dob: {
      component: DobComponent,
      onChange: handleDobChange,
      selectedData: selectedData
  },
    radio: {
      component: RadioInput,
      onChange: handleRadioChange
    },
    dropdown: {
      component: DropdownV1,
      onChange: handleDropdown
    },
    textarea: {
      component: TextArea,
      onChange: handleChange
    },
    location: {
      component: Location,
      onChange: handleChange,
      selectedData: selectedData,
      setSelectedData: setSelectedData,

    },
    subheader: {
      component: SubHeader,
    },
    upload: {
      component: Upload,
      clearFieldError
    },
    label: {
      component: Label,
    },
    checkbox: {
      component: Checkbox,
      onChange: handleCheckBoxChange,
    },
    otp: {
      component: OTP,
      onChange: handleOTPChange,
    },
    radioquestion: {
      component: RadioQuestion,
      onChange: handleRadioQuestionChange,
    },
    radiocheckbox: {
      component: RadioCheckbox,
      onChange: handleRadioCheckboxChange,
    },
    toggle: {
      component: Toggle,
      onChange: handleToggleChange,
      setSelectedData: setSelectedData,
      selectedData: selectedData
    },
    liveness: {
      component: Liveness,
      onChange: handleChange,
      selectedData: selectedData,
      setSelectedData: setSelectedData,
    },
    autoComplete: {
      component: InputSuggestion
    },

    multiselect_checkbox: {
      component: MultiSelectCheckbox,
    },
    multiselect_dropdown: {
      component: MultiSelectDropdown,
    },
    singleselect_dropdown: {
      component: SingleSelectDropdown,
    } 

  }

  const renderFields = (data) => {
    const { component: Component, ...restProps } = FieldMap[data?.type];
    const finalProps = {
      ...restProps,
      ...data,
      ...data.error_messages
    }

    return <Component {...finalProps} />
  }

  return (
    <Container>
      {
        inputFields?.map((item, index) => {
          const value = getSelectedValue(item)
          const isRenderAllowed = checkFieldVisibility(item);
          const error = formErr?.[item.name]?.err || "";

          return (
            isRenderAllowed &&
            <Fragment key={index}>
              {renderFields({ ...item, value, error })}
            </Fragment>
          )
        })
      }

    </Container>
  )
}

export default CardForm